// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadButton_downloadButton__3XcCj","fullWidth":"DownloadButton_fullWidth__1U271"};